module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_08.5cf52fd0.jpg";